<div class="usa-breadcrumb" role="navigation" aria-label="Breadcrumbs,,">
  <ol class="usa-breadcrumb__list">
    <li class="usa-breadcrumb__list-item">
      <a routerLink="/" class="usa-breadcrumb__link"><span>Home</span></a>
    </li>
    @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
      <li
        class="usa-breadcrumb__list-item"
        [class.usa-current]="last"
        [attr.aria-current]="last ? 'page' : null"
      >
        @if (!last) {
          <a [routerLink]="breadcrumb.URL" class="usa-breadcrumb__link"
            ><span>{{ breadcrumb.Label }}</span></a
          >
        }
        @if (last) {
          <span>{{ breadcrumb.Label }}</span>
        }
      </li>
    }
  </ol>
</div>
